import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {InSubject} from '@atmi/core/utils';

import {BehaviorSubject, firstValueFrom} from 'rxjs';
import {filter, first} from 'rxjs/operators';

import {filePath} from '@atmi/core';

import {ImagePickerDialogComponent} from '@sim/media/dialogs/image-picker-dialog/image-picker-dialog.component';
import {Media, MediaExt} from '@sim/media/models/media';
import {MediaService} from '@sim/media/services/media.service';
import {extractMediaTypeFromPath} from '@sim/media/utils';

import {UIMediaService} from '../../services/ui-media.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-media-form-view',
  styleUrls: ['./media-form-view.component.scss'],
  templateUrl: './media-form-view.component.html',
})
export class MediaFormViewComponent {

  /** Media types to exclude */
  @Input() excludedExtensions: MediaExt[] = [];

  @Input() @InSubject() mediaId?: string;
  readonly mediaIdChange = new BehaviorSubject<undefined | string>(undefined);

  @Output() readonly update = new EventEmitter<Media>();

  readonly media$ = new BehaviorSubject<Media | undefined>(undefined);

  get media() {
    return this.media$.value;
  }

  constructor(
    @Inject(filePath) private readonly fileUrl: string,
    private readonly cd: ChangeDetectorRef,
    private readonly dialog: MatDialog,
    private readonly mediaApi: MediaService,
    readonly uiMediaService: UIMediaService,
  ) {

    this.mediaIdChange
      .pipe(
        filter((id): id is string => !!id)
      )
      .subscribe(async (id) => {
        const media = await firstValueFrom(this.mediaApi.get(id).pipe(first()));
        const previewUrl = `${this.fileUrl}${media.previewUrl}`;
        const type = extractMediaTypeFromPath(media.path);

        this.media$.next({...media, previewUrl, type});
      });
  }

  removeMediaHandler() {
    this.media$.next(undefined);
    this.update.emit(undefined);
  }

  async showMediaPickerHandler() {
    const ref = this.dialog.open(
      ImagePickerDialogComponent,
      {
        data: {selection: 'single', excludedExtensions: this.excludedExtensions},
        maxHeight: '95vh',
        width: '840px',
      },
    );
    const res: Array<Media & { id: string }> | undefined = await firstValueFrom(ref.afterClosed().pipe(first()));

    if (res && res.length > 0) {
      const m = res[0];

      this.media$.next(m);
      this.update.emit(m);

      this.cd.markForCheck();
    }
  }
}
